import App from './App.svelte';
import { setup } from 'svelte-match-media';
window.onunhandledrejection = window.onerror = function (e) {
    console.log(e);
};
setup({
    desktop: 'screen and (min-width: 1200px)',
    tablet: 'screen and (min-width: 769px) and (max-width: 1199px)',
    mobile: 'screen and (max-width: 768px)'
});
const target = document.querySelector('.JewelleryBuilder');
if (!target) {
    throw new Error('Cannot start Jewellery Builder');
}
const app = new App({ target });
export default app;
